import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentProcessDetailsComponent } from './pages/document-process-details/document-process-details.component';
import { DocumentsGridComponent } from './pages/documents-grid/documents-grid.component';

const routes: Routes = [
    { path: '', component: DocumentsGridComponent },
    { path: 'documents', component: DocumentsGridComponent },
    { path: 'details/:document-process-id', component: DocumentProcessDetailsComponent }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [],
    declarations: [],
})
export class DocumentsGridRouterModule { }